// Tile.tsx
import { classnames } from '@/utils/classnames'
import s from './Tile.module.scss'
import { ButtonOrLink } from '@/components/ButtonOrLink'
import Image from 'next/image'

export type TileData = {
  title?: { bold: string; normal?: string }
  text: string
  link?: { text: string; url: string }
  image?: string
  iconName?: string
}

type TileProps = {
  data: TileData
  IconComponent?: React.FC<{ width?: number; height?: number }>
}

export function Tile({ data, IconComponent }: TileProps) {
  const { title, text, link, image } = data

  return (
    <div className={classnames(s.container, { [s.withImage]: !!image })}>
      {image && (
        <div className={s.bgImage}>
          <Image src="/photos/girl-in-car.webp" alt="" fill loading="lazy" />
        </div>
      )}

      <div className={s.content}>
        {title && IconComponent && (
          <div className={s.iconCircle}>
            <IconComponent width={26} height={26} />
          </div>
        )}

        {title && (
          <h3 className={s.title}>
            <strong>{title.bold}</strong>
            {title.normal && <span>{title.normal}</span>}
          </h3>
        )}

        <p className={s.text}>{text}</p>

        {link && (
          <ButtonOrLink
            as="link"
            href={link.url}
            variant="text"
            classes={s.pulseLink}
            iconRight="Arrow2Icon"
          >
            {link.text}
          </ButtonOrLink>
        )}
      </div>
    </div>
  )
}
